import * as React from "react";
import * as ReactDOM from "react-dom";
import { ReactifySearchLiquidFactory, Sensors, CustomComponent } from "@usereactify/search";

import { Results } from "./Results/results";
import Filters from "./components/Filters/filters"
import { AppProvider } from '../context/AppContext';
 
if (window.location.pathname.startsWith("/collection")) {
  const ReactifySearchFactory = new ReactifySearchLiquidFactory({
    mode: "collection",
    includeFields: ["*"],
    excludeFields: [],
    shopifyPermanentDomain: "bassike.myshopify.com",
    additionalComponentIds: ["CollectionProductFilter"],
  });
  const ReactifySearchProvider = ReactifySearchFactory.getProvider();
  const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();
  const ReactifySearchData = ReactifySearchFactory.getData();

  ReactDOM.render(
    <React.StrictMode>
      <ReactifySearchProvider>
        <AppProvider>
          <Sensors />
          <CustomComponent
            componentId="CollectionProductFilter"
            customQuery={() => {
              const query = {
                bool: {
                  must: [
                    { match: { published: true } },
                    // {
                    //   bool: {
                    //     should: [
                    //       { range: { "variants.inventory_quantity": { "gt": 0 } } },
                    //       { term: { tags: "coming soon" } }
                    //     ],
                    //     minimum_should_match: 1
                    //   }
                    // } 
                  ],
                  must_not: [
                    { term: { tags: "hidden" } }
                  ]
                }
              };
              return { query };
            }}
          />
          <Filters />
          <Results />
        </AppProvider>
      </ReactifySearchProvider>
    </React.StrictMode>,
    ReactifySearchMountNode
  );
}
